import { ActionNextStage, CaseStageAction } from "../../../../api/caseStages";
import { AcceptCreatedCase } from "./AcceptCreatedCase";
import { AcceptFwdCase } from "./AcceptFWDCase";
import { ApproveIOAppAuth } from "./ApproveIO";
import { AssignDO } from "./AssignDO";
import { AssignIO } from "./AssignIO";
import { AssignIOAppAuth } from "./AssignIOAppAuth";
import { MarkCompletedWithRemarks } from "./MarkCompletedWithRemarks";
import { RejectCreatedCase } from "./RejectedCreatedCase";
import { RejectFwdCase } from "./RejectFWDCase";
import { ReturnCaseWithInfo } from "./ReturnCaseWithInfo";

export interface CaseStageActionsProps {
    actions: ActionNextStage[];
}

export const CaseStageActions: React.FC<CaseStageActionsProps> = ({
  actions
}) => {
  return (
    <>
      {actions.map((action) => {
        switch (action.action) {

          case CaseStageAction.ACCEPT_CREATED_CASE:
            return (
              <AcceptCreatedCase
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.REJECT_CREATED_CASE:
            return (
              <RejectCreatedCase
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.ACCEPT_FWD_CASE:
            return (
              <AcceptFwdCase
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.REJECT_FWD_CASE:
            return (
              <RejectFwdCase
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.ASSIGN_DO:
            return (
              <AssignDO
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.ASSIGN_IO:
            return (
              <AssignIO
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.ASSIGN_IO_APP_AUTH:
            return (
              <AssignIOAppAuth
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.APPROVE_IO_APP_AUTH:
            return (
              <ApproveIOAppAuth
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.MARK_COMPLETE_WITH_REMARKS:
            return (
              <MarkCompletedWithRemarks
                key={action.action}
                next_stage={action.next_stage}
              />
            );

          case CaseStageAction.RETURN_CASE_WITH_INFO:
            return (
              <ReturnCaseWithInfo
                key={action.action}
                next_stage={action.next_stage}
              />
            );
          
          default:
            return null;
        }
      })}
    </>
  );
};
